module.exports = __webpack_public_path__ + "img/blue-arrow.6613b11a.svg";